const COOKIE_JWT = 'token';

const query = {
  'screen-xs': {
    maxWidth: 575,
  },
  'screen-sm': {
    minWidth: 576,
    maxWidth: 767,
  },
  'screen-md': {
    minWidth: 768,
    maxWidth: 991,
  },
  'screen-lg': {
    minWidth: 992,
    maxWidth: 1199,
  },
  'screen-xl': {
    minWidth: 1200,
    maxWidth: 1599,
  },
  'screen-xxl': {
    minWidth: 1600,
  },
};

const SOURCE_OPTIONS = {
  NEW: 1,
  OLD: 2,
  ALL: 0,
}

const STATUS_TYPES = {
  HIDDEN: 0,
  ACTIVE: 1,
  ALL: 2,
};
const STATUS_REVIEW = {
  NOTREVIEW: 0,
  REVIEWED: 1,
  REVIEWING: 2,
  AUTOREVIEW: 3,
  ALL: 4,
};

const GENDER_TYPES = {
  ALL: 2,
  MALE: 1,
  FEMALE: 0,
};
const REVIEW_STATUS_TYPES = {
  NOREVIEW: 0,
  NOTYETREVIEW: 1,
  REVIEWING: 2,
  REVIEWED: 3,
  ALL: 4,
};

const GENDER_OPTIONS = [
  {
    value: 1,
    label: 'Nam',
  },
  {
    value: 0,
    label: 'Nữ',
  },
];

const STATUS_OPTIONS = [
  {
    value: 2,
    label: 'Tất cả',
  },
  {
    value: 1,
    label: 'Kích hoạt',
  },
  {
    value: 0,
    label: 'Khóa',
  },
];

const STATUS_STOCKS_IN = {
  ALL: 2,
  STOCKED: 1,
  NOTYETSTOCKED: 0,
};

const TYPE_NOTIFY = {
  MAIL: 'MAIL',
  ANNOUNCE: 'ANNOUNCE',
};

export {
  query,
  // formatter,
  COOKIE_JWT,
  STATUS_TYPES,
  STATUS_OPTIONS,
  GENDER_TYPES,
  STATUS_REVIEW,
  REVIEW_STATUS_TYPES,
  GENDER_OPTIONS,
  STATUS_STOCKS_IN,
  TYPE_NOTIFY,
  SOURCE_OPTIONS
};
